import { render, staticRenderFns } from "./EntregasPage.vue?vue&type=template&id=39d4f8f4&"
import script from "./EntregasPage.vue?vue&type=script&lang=js&"
export * from "./EntregasPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports